import Hero from "../components/sections/Hero";
import TrustBar from "../components/sections/TrustBar";
import Services from "../components/sections/Services";
import WhyChooseUs from "../components/sections/WhyChooseUs";
import CTASection from "../components/sections/CTASection";
import BookingForm from "../components/sections/BookingForm";
import ContactSection from "../components/sections/ContactSection";

import BeforeAfter from "../components/sections/BeforeAfter";

const Home = () => {
  return (
    <main data-testid="home-page">
      <Hero />
      <TrustBar />
      <Services />
      <BeforeAfter />
      <WhyChooseUs />
      <CTASection />
      <BookingForm />
      <ContactSection />
    </main>
  );
};

export default Home;

